var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captain-wrapper"},[_c('div',{ref:"captain",staticClass:"captain"},[_c('div',{staticClass:"distress-message"},[_vm._v(" Captain we seem to have hit some kind of energy distortion!!! ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }